import {lazy} from 'react';

export const foundryAgentPagesConfigs = [
  {
    auth: ['user'],
    routes: [
      {
        // More specific route with param must come first
        path: '/foundry-agent/chat/:threadId',
        component: lazy(() => import('./chat/FoundryAgentChat')),
      },
      {
        // Base route comes second (acts as fallback)
        path: '/foundry-agent/chat',
        component: lazy(() => import('./chat/FoundryAgentChat')),
      },
    ],
  },
];
